import { REPORT_HISTORY_TABLE_STRINGS } from "constants/constantStrings";

import ReportDownloadRenderer from "./ReportDownloadRenderer";

const createdDateComparator = (date1, date2) => new Date(date1) - new Date(date2);
const dateRangeComparator = (date1, date2) => {
  const DATE1_START = date1.split(" to ")[0];
  const DATE2_START = date2.split(" to ")[0];
  return new Date(DATE1_START) - new Date(DATE2_START);
};

export const getReportsHistoryTableColDefs = filter => [
  {
    field: "ReportName",
    headerName: REPORT_HISTORY_TABLE_STRINGS.reportTitle,
    flex: 2,
    editable: false,
    filter
  },
  {
    field: "DateRange",
    headerName: REPORT_HISTORY_TABLE_STRINGS.dateRange,
    flex: 2,
    editable: false,
    comparator: dateRangeComparator,
    filter
  },
  {
    field: "DateCreated",
    headerName: REPORT_HISTORY_TABLE_STRINGS.dateCreated,
    flex: 2,
    editable: false,
    comparator: createdDateComparator,
    filter
  },
  {
    field: "ReportSize",
    headerName: REPORT_HISTORY_TABLE_STRINGS.reportSize,
    flex: 1,
    editable: false,
    filter
  },
  {
    field: "",
    headerName: REPORT_HISTORY_TABLE_STRINGS.downloadReport,
    editable: false,
    sortable: false,
    cellRendererFramework: ReportDownloadRenderer
  }
];
